import { BACKUP_CONSENT_FIELD_NAMES, CREDENTIAL_TYPES, FIELD_NAMES } from 'utils/constants';

export const ERROR_TEXT_CHECKED_FIELD_NO_TEXT = 'This field cannot be empty if checkbox is checked.';
export const ERROR_TEXT_EMPTY_FORM_NAME = 'Form Name is required.';
export const ERROR_TEXT_EMPTY_REQUIRED_FIELD = 'This field must have a value.';
export const ERROR_TEXT_EMPTY_STEP = 'Step cannot be empty.';
export const ERROR_TEXT_NO_DEFAULT_VALUE = 'When field is hidden a default value must exist.';
export const ERROR_TEXT_NO_DEGREE_OFFERING = 'You must select a valid degree offering to add fields to this form.';
export const ERROR_TEXT_NO_DROPDOWN_OPTION_LABEL = 'A dropdown option must have a valid label.';
export const ERROR_TEXT_NO_FIELD_EMAIL = 'One or more branches is missing email';
export const ERROR_TEXT_NO_FIELD_FIRST_NAME = 'One or more branches is missing first name';
export const ERROR_TEXT_NO_FIELD_GDPR_CONSENT = 'One or more branches is missing GDPR Consent';
export const ERROR_TEXT_NO_CONSENT_GDPR = `One or more branches is missing either the GDPR consent section, or one of the following fields:\n• ${BACKUP_CONSENT_FIELD_NAMES.join('\n• ')}`;
export const ERROR_TEXT_NO_CONSENT_GEO = `One or more branches is missing both US and GDPR consent sections, or one of the following fields:\n• ${BACKUP_CONSENT_FIELD_NAMES.join('\n• ')}`;
export const ERROR_TEXT_NO_CONSENT_US = `One or more branches is missing either US consent sections, the Lead Share section, or one of the following fields:\n• ${BACKUP_CONSENT_FIELD_NAMES.join('\n• ')}`;
export const ERROR_TEXT_IMPLIED_CONSENT = 'US or GDPR consent sections are present with never or always GDPR Consent selected';
export const ERROR_TEXT_LEAD_SHARE_WITH_US_CONSENT = 'Lead Share and US Consent Field appear together';
export const ERROR_TEXT_LEAD_SHARE_WITH_GDPR_CONSENT = 'Lead Share and GDPR Consent Field appear together';
export const ERROR_TEXT_NO_FIELD_LAST_NAME = 'One or more branches is missing last name';
export const ERROR_TEXT_NO_FIELD_US_CONSENT = 'One or more branches is missing US Consent';
export const ERROR_TEXT_NO_PROGRAM_OF_STUDY = 'You must select a valid program of study to add fields to this form.';
export const ERROR_TEXT_NO_SELECTED_CHANNEL = 'At least one communication channel must be selected.';
export const ERROR_TEXT_NO_SELECTED_DROPDOWN_OPTIONS = 'At least one dropdown option must be selected.';
export const ERROR_TEXT_NO_GDPR_SETTING = 'A GDPR consent setting is required.';
export const ERROR_TEXT_NO_THANK_YOU_URL = 'Add a thank you routing url or uncheck this answer.';
export const ERROR_DISCLAIMER_REQUIRED = 'At least one disclaimer is required.';
export const TOP_LEVEL_ERROR_DATA = {
  name: {
    title: 'Name',
    text: ERROR_TEXT_EMPTY_FORM_NAME,
  },
  degreeOffering: {
    title: 'Degree Offering',
    text: ERROR_TEXT_NO_DEGREE_OFFERING,
  },
  gdprSetting: {
    title: 'GDPR Setting',
    text: ERROR_TEXT_NO_GDPR_SETTING,
  },
  programOfStudy: {
    title: 'Program Of Study',
    text: ERROR_TEXT_NO_PROGRAM_OF_STUDY,
  },
};

export const errorTextImpliedHasInvalidField = (fieldName, credentialType) => {
  const errorString = 'This field is not allowed on implied consent forms ';
  if ([FIELD_NAMES.CONSENT_GDPR, FIELD_NAMES.CONSENT_NON_GDPR].includes(fieldName)) {
    if (credentialType === CREDENTIAL_TYPES.SHORT_COURSE) {
      return errorString.concat('(use gdprProspect2uOptIn field instead).');
    }
    return errorString.concat('(use Lead Share field instead).');
  }
  if (fieldName === FIELD_NAMES.EMAIL_OPT_OUT) {
    return errorString.concat('(will be implied from email)');
  }
  if (fieldName === FIELD_NAMES.PHONE_OPT_OUT) {
    return errorString.concat('(will be implied from phone)');
  }
  return undefined;
};
